export default __webpack_public_path__ + "static/media/warning.267da2b6.svg";